export enum Priority {
	LOW = 'low',
	NORMAL = 'normal',
	HIGH = 'high',
	URGENT = 'urgent',
}

export const PriorityValues = Object.values(Priority);

export const PriorityLabels: Record<Priority, string> = {
	[Priority.LOW]: 'Low',
	[Priority.NORMAL]: 'Normal',
	[Priority.HIGH]: 'High',
	[Priority.URGENT]: 'Urgent',
};

/**
 * Static value→{label, color} mapping for the list-builder `valueMapping`
 * on a `displayStyle: 'badge'` field. Colors match the Tailwind
 * `success`/`warning`/`danger` palette intent (calm green for low,
 * neutral gray for normal, amber for high, red for urgent) and stay
 * legible in both light and dark mode via the resolveThemeColor path.
 */
export const PriorityBadgeValueMapping: ReadonlyArray<{
	value: Priority;
	displayText: string;
	color: { text: string; bg: string };
}> = [
	{
		value: Priority.URGENT,
		displayText: PriorityLabels[Priority.URGENT],
		color: { text: '#b91c1c', bg: '#fee2e2' },
	},
	{
		value: Priority.HIGH,
		displayText: PriorityLabels[Priority.HIGH],
		color: { text: '#b45309', bg: '#fef3c7' },
	},
	{
		value: Priority.NORMAL,
		displayText: PriorityLabels[Priority.NORMAL],
		color: { text: '#475569', bg: '#e2e8f0' },
	},
	{
		value: Priority.LOW,
		displayText: PriorityLabels[Priority.LOW],
		color: { text: '#0e7490', bg: '#cffafe' },
	},
];
